import React from "react";
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";

const Contact = () => {
  return (
    <>
      <Navbar />

      <section
        className="page-banner"
        style={{ backgroundImage: 'url("/assets/images/hero.jpg")' }}
      >
        <div className="overlay"></div>
        <div className="banner-content container">
          <h1>Contact Us</h1>
          <p>We'd love to hear from you. Get in touch with us.</p>
        </div>
      </section>

      <main>
        <section className="contact-form container">
          <h2>Get in Touch</h2>
          <form action="#" method="post">
            <div className="form-group">
              <label htmlFor="name">
                Name<span>*</span>
              </label>
              <input type="text" id="name" name="name" required placeholder="Your full name" />
            </div>
            <div className="form-group">
              <label htmlFor="email">
                Email<span>*</span>
              </label>
              <input
                type="email"
                id="email"
                name="email"
                required
                placeholder="Your email address"
              />
            </div>
            <div className="form-group">
              <label htmlFor="message">
                Message<span>*</span>
              </label>
              <textarea
                id="message"
                name="message"
                rows="6"
                required
                placeholder="Your message"
              ></textarea>
            </div>
            <button type="submit" className="btn">
              Send Message
            </button>
          </form>
        </section>
      </main>

      <Footer />
    </>
  );
};

export default Contact;